import React from 'react';
import { Typography, Card } from 'antd';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';
import AnswersList from '../components/answersList/answersList';

const { Title } = Typography;

// Página de observaciones (Categoría => Dimensión) con mismo layout que PageTextualAnswersGeneral
const PageCultureObservations = ({
  selectedEvaluation,
  category,
  dimension,
  texts = [],
  pageNumber,
  pagePos
}) => {
  const backgroundStyle = {
    backgroundImage: `url('/informs/pagina.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left top',
    backgroundSize: '100% auto',
  };

  const questionLabel = `Observaciones — ${dimension}`;
  const answers = texts;

  return (
    <div className="pdf-page internal-page">
      <div className="internal-page-content" style={backgroundStyle}>
        <AutoSizeTitle text={selectedEvaluation?.evl_title} />
        <div className="internal-page-info" style={{ position: 'relative' }}>
          <Card
            style={{
              border: 'none',
              backgroundColor: 'white',
              boxShadow: 'none',
            }}
            styles={{ body: { padding: '0' } }}
          >
            <Title level={4} style={{ color: '#339C98', marginBottom: 12, width: 'calc(100% - 150px)' }}>
              {`Observaciones — ${category}`}
            </Title>
            <AnswersList question={questionLabel} answers={answers} pagePos={pagePos} isAnswer={false} />
          </Card>
        </div>
        <div className="internal-page-number">{pageNumber}</div>
      </div>
    </div>
  );
};

export default PageCultureObservations;
